import { render, staticRenderFns } from "./BestellungRowSofort.vue?vue&type=template&id=eb6fd646"
import script from "./BestellungRowSofort.vue?vue&type=script&lang=ts"
export * from "./BestellungRowSofort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports